import { Platform, TextStyle } from "react-native";
import { useTheme } from "./AHTheme/AHTheme";
import { AHText, AHTextFonts } from "./Text";
import React from "react";
import { AHIcon } from "./AHIcon";

const webElipsisHeadHack: TextStyle =
  Platform.OS === "web" ? { direction: "rtl", textAlign: "left" } : {};

export function SubjectBreadcrumbs(props: {
  breadcrumbs: readonly string[];
  trailingBreadcrumb?: string;
  highlightLast?: boolean;
  placeholder?: string;
}) {
  const theme = useTheme();
  let breadcrumbs = [...props.breadcrumbs];
  if (props.trailingBreadcrumb) {
    breadcrumbs.push(props.trailingBreadcrumb);
  }
  return (
    <AHText
      style={{
        flex: 1,
        ...webElipsisHeadHack,
      }}
      numberOfLines={1}
      type="subtitle"
      font={AHTextFonts.MEDIUM}
      color="text-secondary"
      ellipsizeMode="head"
    >
      {breadcrumbs.length === 0 && props.placeholder
        ? props.placeholder
        : breadcrumbs.map((breadcrumb, index) => {
            const isLast = breadcrumbs.length - 1 === index;
            return (
              <React.Fragment key={index + ""}>
                <AHText
                  font={
                    isLast && props.highlightLast
                      ? AHTextFonts.BOLD
                      : AHTextFonts.MEDIUM
                  }
                  style={{
                    color:
                      isLast && props.highlightLast
                        ? theme["text-primary"]
                        : undefined,
                  }}
                >
                  {breadcrumb}
                </AHText>
                {isLast ? null : (
                  <AHIcon
                    type="chevron-right"
                    color="text-secondary"
                    size="xsmall"
                  />
                )}
              </React.Fragment>
            );
          })}
      {"\u200E"}
    </AHText>
  );
}
